import React from 'react'
import ChevronDownIcon from "../../../assets/icons/ChevronDownIcon";
import colors from "../../../utils/Colors";

const AccordionItem = ({
                           value = null,
                           triggerContent,
                           triggerIcon = null,
                           children,
                           rotateIcon = true,
                           onTriggerClick,
                           isOpen,
                           itemStyle = {},
    }) => {

    return (
        <div id={`accordion-item-${value}`} className="accordion-item" style={itemStyle}>
            <div
                id={`accordion-item-trigger-${value}`}
                className="accordion-item-trigger"
                onClick={onTriggerClick}
            >
                {triggerContent}

                <div className={'accordion-item-trigger-icon' + (rotateIcon ? ' rotate' : '')}>
                    {
                        triggerIcon ?
                            triggerIcon({ isOpen })
                            :
                            <ChevronDownIcon
                                strokeWidth={2}
                                style={{color: colors.silverBlueDark}} stroke="currentColor"
                                width={18}
                                height={18}
                            />
                    }
                </div>
            </div>

            <div className="accordion-item-content">
                <div className="accordion-item-content-inner">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default AccordionItem;


// WEBPACK FOOTER //
// ./src/components-new/ui/Accordion/AccordionItem.jsx